import { render } from "./BalanceTests.vue?vue&type=template&id=e6633ca8"
import script from "./BalanceTests.vue?vue&type=script&lang=js"
export * from "./BalanceTests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__